'use strict';
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toIntegerOrInfinity = require('../internals/to-integer-or-Infinity');
var $RangeError = RangeError;

/**
 * Array.prototype.with的具体实现
 * @param {any[]} O 指向执行with方法时的数组
 * @param {ArrayConstructor} C 数组构造器
 * @param {number} index 索引
 * @param {any} value 值
 * @returns {any[]} 全新的数组
 */
module.exports = function(O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) {
    throw new $RangeError('Incorrect index');
  }
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) {
    A[k] = k === actualIndex ? value : O[k];
  }
  return A;
};
